var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "200",
      height: "150",
      label: "用户信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("OPENID：" + _vm._s(scope.row.openId))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "350",
      height: "150",
      label: "登录信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("最后登录时间：" + _vm._s(scope.row.lastLoginTime))]), _c("p", [_vm._v("最后活跃时间：" + _vm._s(scope.row.lastUpdateTime))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("角色ID：" + _vm._s(scope.row.roleId))]), _c("p", [_vm._v("角色名：" + _vm._s(scope.row.roleName))]), _c("p", [_vm._v("区服ID：" + _vm._s(_vm.serverList[scope.row.serverId]))]), scope.row.serverIdMerge != 0 ? _c("p", [_vm._v(" 区服ID(合服后)：" + _vm._s(_vm.serverList[scope.row.serverIdMerge]))]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "350",
      height: "150",
      label: "角色属性"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("角色等级: " + _vm._s(scope.row.roleVipLevel))]), _c("p", [_vm._v("创角时间：" + _vm._s(scope.row.createRoleTime))]), _c("p", [_vm._v("创角IP：" + _vm._s(scope.row.ip))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "300",
      height: "150",
      label: "付费信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("总付费金额: " + _vm._s(scope.row.totalRmb))]), _c("p", [_vm._v("首次付费时间：" + _vm._s(scope.row.firstPayTime))]), _c("p", [_vm._v("最后付费时间：" + _vm._s(scope.row.lastPayTime))])];
      }
    }])
  })], 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };